export const frontmatter = {
    "title": "OnnIA Capabilities",
    "description": "The main modules of the OnnIA platform: agent builder, channels, ticketing, contacts, integrations, knowledge base, and governance.",
    "sidebar_label": "Capabilities",
    "sidebar_group": "concepts",
    "sidebar_order": 3,
    "hide_title": true,
    "toc": false
}

export const toc = [
    {
        "depth": 2,
        "id": "platform-modules",
        "value": "Platform Modules"
    },
    {
        "depth": 2,
        "id": "available-channels",
        "value": "Available Channels"
    },
    {
        "depth": 2,
        "id": "how-the-knowledge-base-works",
        "value": "How the Knowledge Base Works"
    }
]